import React, { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { documentTemplateTools } from 'components/organisms/document/parts/topbar/tools';
import { TemplateRocketlaneDocument } from 'components/organisms/templates/commons/rocketlane-document';
import { SpaceTab } from 'data/space-tabs';
import {
  DocumentTemplateSourceType,
  updateDocumentTemplateAction,
} from 'data/templates/documents';
import { useGetDocumentById } from 'data/templates/documents/hooks/use-get-document-by-id';
import { DocumentTemplateMoreActions } from './more-actions';

const MoreActions = styled(DocumentTemplateMoreActions)`
  position: absolute;
  top: var(--spacing-03);
  right: var(--layout-01);
  z-index: var(--zindex-layer-09);
`;

const Wrapper = styled.div`
  position: relative;
  height: 100%;
`;

const abstractDocId = (url) => url.split('/').pop();

export const TemplateRocketlaneDocumentTabContent: FC<{
  data: SpaceTab;
  spaceId: number;
}> = ({ data, spaceId }) => {
  const docId = abstractDocId(data.url);
  const dispatch = useDispatch();
  const [isReadonly, setIsReadonly] = useState(false);

  const documentTemplateStore = useGetDocumentById(docId);

  const onTitleChange = (title: string) => {
    if (document) {
      const template = {
        templateId: docId,
        templateName: title,
      };

      dispatch(
        updateDocumentTemplateAction({
          template,
          spaceTab: data,
          spaceId,
        }),
      );
    }
  };

  useEffect(() => {
    setIsReadonly(
      documentTemplateStore?.template?.sourceType ===
        DocumentTemplateSourceType.Default,
    );
  }, [documentTemplateStore]);

  return (
    <Wrapper>
      <MoreActions data={data} />
      <TemplateRocketlaneDocument
        docId={docId}
        editorProps={{ readOnly: isReadonly }}
        onTitleChange={onTitleChange}
        tools={documentTemplateTools}
      />
    </Wrapper>
  );
};
